export default {
  setUser: (state, value) => (state.user = value),
  setActiveInvite: (state, value) => (state.activeInvite = value),
}
